import { Injectable, InjectionToken } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { TeamStore } from '@web-portal/domains/shared/domain-models';

export const TEAM_FACADE_TOKEN = new InjectionToken<TeamFacade>('TeamFacade', {
  providedIn: 'root',
  factory: () => new TeamFacade(),
});

@Injectable()
export class TeamFacade {
  private readonly teamStore = new TeamStore();

  public readonly teams = this.teamStore.teams;
  public readonly teams$ = toObservable(this.teams);
  public readonly selectedTeam = this.teamStore.selectedTeam;
}
